// utils.js

/**
 * Универсальное хранилище выбранного пользователем города (без jQuery).
 * Использует localStorage с fallback на cookie.
 * Ключ: 'city-name'
 * @type {{key: string, set: (function(string): boolean), get: (function(): string), remove: (function(): void)}}
 */
export const CityStorage = {
	key: 'city-name',

	/**
	 * Сохраняет значение города (если непустое).
	 * @param {string} city
	 * @returns {boolean} true, если удалось сохранить
	 */
	set(city) {
		try {
			const val = String(city || '').trim();
			if (!val) return false;
			// localStorage
			try { localStorage.setItem(this.key, val); } catch {}
			// cookie (fallback)
			try {
				document.cookie = `${this.key}=${encodeURIComponent(val)}; path=/; max-age=${60 * 60 * 24 * 365}`;
			} catch {}
			return true;
		} catch {
			return false;
		}
	},

	/**
	 * Возвращает сохранённый город (или пустую строку).
	 * @returns {string}
	 */
	get() {
		// localStorage
		try {
			const v = localStorage.getItem(this.key);
			if (v) return v;
		} catch {}
		// cookie (fallback) — без RegExp, безопасный разбор
		try {
			return getCookie(this.key);
		} catch {
			return '';
		}
	},

	/**
	 * Удаляет сохранённый город.
	 * @returns {void}
	 */
	remove() {
		try { localStorage.removeItem(this.key); } catch {}
		try { document.cookie = `${this.key}=; path=/; max-age=0`; } catch {}
	}
};

/**
 * Читает cookie по имени без RegExp.
 * @param {string} name
 * @returns {string}
 */
function getCookie(name) {
	const all = document.cookie || '';
	if (!all) return '';
	const parts = all.split(/;\s*/);
	for (const part of parts) {
		const eq = part.indexOf('=');
		if (eq === -1) continue;
		const key = decodeURIComponent(part.slice(0, eq));
		if (key === name) {
			return decodeURIComponent(part.slice(eq + 1));
		}
	}
	return '';
}

/**
 * Обеспечивает (создаёт при необходимости) и возвращает список подсказок рядом с input.
 * Возвращает <ul class="selectric-list">, очищенный и показанный.
 * @param {jQuery} $input - Инпут, рядом с которым создаём список
 * @returns {jQuery} - Ссылка на созданный и очищенный список (<ul>)
 */
export function ensureListContainer($input) {
	const $wrap = $input.closest(".selectric-items");
	if (!$wrap.find(".selectric-list").length) {
		$input.after("<div class='quick__search helpinput'><ul class='selectric-list'></ul></div>");
	}
	const $list = $wrap.find(".selectric-list");
	$list.empty().parent().show();
	return $list;
}

/**
 * Безопасно создаёт элемент <li> для подсказки с текстом и data-атрибутами.
 * @param {string} text - Текст элемента
 * @param {object} [data={}] - Набор данных для $.data()
 * @returns {jQuery} - Элемент <li>
 */
export function createListItem(text, data = {}) {
	const $li = $("<li>", { class: "selectric-list-option" }).text(text);
	for (let key in data) {
		if (Object.prototype.hasOwnProperty.call(data, key)) {
			$li.data(key, data[key]);
		}
	}
	return $li;
}

/**
 * Простая функция-дебаунсер.
 * @param {Function} fn - Функция для вызова
 * @param {number} [delay=300] - Задержка в мс
 * @returns {Function} - Дебаунс-обёртка
 */
export function debounce(fn, delay = 300) {
	let timeout;
	return function debounced(...args) {
		clearTimeout(timeout);
		timeout = setTimeout(() => fn.apply(this, args), delay);
	};
}
